import { Link, useNavigate } from '@tanstack/react-router';
import { useSignOutAction } from '@rhino-project/core/queries';
import { useHarborlightSession } from '../../hooks/useHarborlightSession';

// Ported 1:1 from the source repository (client/src/components/AppLayout.jsx).
// The Harborlight app shell: sticky top nav with role-aware links, user
// identity + Sign out, and the footer. Wraps every owner-scoped app screen.
export const HarborlightLayout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const { userName, role, isStaff, ownerParam } = useHarborlightSession();
  const navigate = useNavigate();
  const signOut = useSignOutAction();

  const owner = ownerParam ?? '';

  function handleLogout() {
    signOut.mutate(undefined as never, {
      onSettled: () => navigate({ to: '/login' })
    });
  }

  return (
    <div className="app-shell">
      <nav className="navbar navbar-expand-lg top-nav sticky-top">
        <div className="container">
          <Link className="navbar-brand brand-mark fs-3 mb-0" to="/">
            room stay 1
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
            aria-controls="mainNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="mainNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 gap-lg-1">
              {isStaff && (
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="/$owner"
                    params={{ owner }}
                    activeProps={{ className: 'nav-link active' }}
                    activeOptions={{ exact: true }}
                  >
                    Dashboard
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/$owner/rooms"
                  params={{ owner }}
                  activeProps={{ className: 'nav-link active' }}
                >
                  Rooms
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/$owner/reservations"
                  params={{ owner }}
                  activeProps={{ className: 'nav-link active' }}
                >
                  {role === 'GUEST' ? 'My bookings' : 'Reservations'}
                </Link>
              </li>
            </ul>
            <div className="d-flex align-items-center gap-3">
              <div className="text-end small">
                <div className="fw-semibold">{userName}</div>
                <div className="text-secondary text-uppercase role-label">
                  {role}
                </div>
              </div>
              <button
                type="button"
                className="btn btn-outline-sea btn-sm"
                onClick={handleLogout}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>
      <main className="container py-4 py-lg-5 flex-grow-1">{children}</main>
      <footer className="py-4 text-center text-secondary small">
        room stay 1 Hotel · Operations console
      </footer>
    </div>
  );
};

export default HarborlightLayout;
